import { Box, Flex, Heading, Text } from '@ghq-abi/design-system';
import { useTranslate } from '@tolgee/react';
import { ListCardDetailsItem } from '../ListCard/ListCardDetailsItem';

interface DefaultDetailsProps {
  employeeId: string;
  band: string;
  positionTitle: string;
  description: string;
}

export function DefaultDetails({
  employeeId,
  band,
  positionTitle,
  description,
}: DefaultDetailsProps) {
  const { t } = useTranslate();

  return (
    <Box
      css={{
        marginTop: '$4',
        padding: '$2',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        border: '1px solid #EEEFF2',
        width: '100%',
      }}
    >
      <Flex justify="between">
        <Flex direction="column" css={{ m: '$4', width: '50%' }}>
          <Heading css={{ fontSize: '$sm', mb: '$4' }}>
            {t('my_tickets.list.details.employee_details')}
          </Heading>
          <Box
            css={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: '$5',
            }}
          >
            <ListCardDetailsItem
              label={t('my_tickets.list.details.employee_id')}
              value={employeeId}
            />
            <ListCardDetailsItem
              label={t('my_tickets.list.details.employee_band')}
              value={band}
            />
            <ListCardDetailsItem
              label={t('my_tickets.list.details.position_title')}
              value={positionTitle}
            />
          </Box>
        </Flex>

        <Flex direction="column" css={{ m: '$4', width: '50%' }}>
          <Heading css={{ fontSize: '$sm', mb: '$4' }}>
            {t('common.description')}
          </Heading>
          <Text>{description}</Text>
        </Flex>
      </Flex>
    </Box>
  );
}
